@if (!(obs | async)) {
  <div class="loader">
    <mat-progress-bar mode="query"></mat-progress-bar>
  </div>
}
<ng-scrollbar>
  <div class="content">
    <ng-content></ng-content>
  </div>
</ng-scrollbar>
